import { useEffect, useState } from 'react';

export function useMultiMapFullscreen() {
  const [fullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    if (!fullscreen) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setFullscreen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [fullscreen]);

  const toggleFullscreen = () => setFullscreen((current) => !current);
  const closeFullscreen = () => setFullscreen(false);

  return {
    fullscreen,
    toggleFullscreen,
    closeFullscreen,
  };
}
